export default __webpack_public_path__ + "static/media/award.8a6a4bc6.svg";